import "../css/Footer.css";
import { useState } from 'react';
import Icon from '@ant-design/icons';
import { useQuery } from "@apollo/client";
import { Flex, Row, Collapse } from "antd";
import { GET_FOOTER } from "../queries";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import ButtonComp from "./ButtonComp";
import useIsMobile from '../utils/isMobile'
import useMediaItem from '../utils/useMediaItem';
import setImageAbsoluteUrl from '../utils/setImageAbosulteUrl';
import { insSVG, linkedinSVG } from '../media/icons';
import { terms } from "langs/termsAndConditions";
import LanguageBtn from "./LanguageSelect";

const { Panel } = Collapse;

const InstagramIcon = (props) => <Icon component={insSVG} {...props} />;
const LinkedinIcon = (props) => <Icon component={linkedinSVG} {...props} />;

const renderMenuItem = (item) => {
  if ((!item.children || item.children.length === 0) && item.parentDatabaseId !== 0) {
    return (
      <a href={item.url} className="b4-body-500 mobile-menu-link">
        {item.label}
      </a>
    );
  }
  return (
    <Collapse bordered={false} ghost expandIconPosition="end">
      <Panel
        key={item.label}
        header={
          <div className="menu-item-header">
            <a
              href={item.url || "#"}
              onClick={(e) => !item.url && e.preventDefault()}
              className={`b4-body-500 ${item.url ? "clickable" : ""}`}
            >
              {item.label}
            </a>
          </div>
        }
      >
        {item.children.map((child) => (
          <div key={child.label} className="b4-body-500 mobile-submenu-item">
            {renderMenuItem(child)}
          </div>
        ))}
      </Panel>
    </Collapse>
  );
};


const GetLogo = ({lang}) => {
  // Transfeera logo
  let { loading: loadingTransfeera, data:dataLogoTransfeera } = useMediaItem('transfeera-logo');
  if (!dataLogoTransfeera) {
    dataLogoTransfeera = getFromLocalStorage('transfeera-logo');
  }

  // Celeris logo
  let { loading: loadingCeleris, data:dataLogoCeleris } = useMediaItem('celeris-logo');
  if (!loadingCeleris) {
    dataLogoCeleris = getFromLocalStorage('celeris-logo');
  }

  if ((loadingTransfeera && !dataLogoTransfeera) || (loadingCeleris && !dataLogoCeleris)) return <p></p>;  
  return (
    <>
      {/* Transfeera Logo */}
      <a href={`https://transfeera.com/`} target="_blank" rel="noreferrer">
        <img
          src={setImageAbsoluteUrl(
            dataLogoTransfeera?.mediaItemBy?.mediaItemUrl
          )}
          alt={dataLogoTransfeera?.mediaItemBy?.title}
          className="logo"
        />
      </a>
      <a href={`https://celerispay.com/`} target="_blank" rel="noreferrer">
        <img
          src={setImageAbsoluteUrl(dataLogoCeleris?.mediaItemBy?.mediaItemUrl)}
          alt={dataLogoCeleris?.mediaItemBy?.title}
          className="logo"
        />
      </a>
    </>
  );
};


const FooterComp = ({ page, lang }) => {

  const currentYear = new Date().getFullYear();

  const isMobile = useIsMobile();
  const slug = `${page}-footer-${lang}`;
  // esto trae el banner antes del footer
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });

  const { loading, error, data } = useQuery(GET_FOOTER, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.footer;
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  // esto trae los items del menu para el footer
  const [menu, setMenu] = useState(() => {
    const cachedMenu = getFromLocalStorage("menuData");
    return cachedMenu ? cachedMenu : [];
  });

  const menuForLanguage = menu.find(item => item[lang]);
  const menuItems = menuForLanguage[lang];

  return (
    <>
      <Flex vertical className="footer">
        {sectionData && (
          <>
            <Flex className="footer-banner">
              <Flex>
                <div
                  className={
                    isMobile ? "h2-headline-500-mobile" : "h2-headline-800"
                  }
                  style={{ color: "#0B1547" }}
                  dangerouslySetInnerHTML={{
                    __html: sectionData?.titulo_footer,
                  }}
                />
              </Flex>
              <Flex className="button-row" style={{ paddingTop: "40px" }}>
                <ButtonComp
                  title={sectionData?.text_boton?.title}
                  url={sectionData?.text_boton?.url}
                  classStyle={"button-yellow-md"}
                />
              </Flex>
            </Flex>
          </>
        )}
        {isMobile ? (
          <div className="mobile-footer-content">
            <div style={{ paddingBottom: "70px" }}>
              <LanguageBtn />
            </div>
            <div className="mobile-footer-item-list">
              {menuItems.map((item) => (
                <div key={item.label} className="menu-item">
                  {renderMenuItem(item)}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Row className="footer-grid-container">
            <div key={"btn-lang"}>
              <LanguageBtn />
            </div>
            {menuItems?.map((item, index) => (
              <div className="footer-item-list" key={index}>
                <h4 className="footer-item-title b5-body-700">{item?.label}</h4>
                <ul className="footer-submenu-list">
                  {item?.children?.map((child, i) => (
                    <a className="" href={child?.url} key={i}>
                      <li className="footer-item-submenu b5-body-400">
                        {child?.label}
                      </li>
                    </a>
                  ))}
                </ul>
              </div>
            ))}
          </Row>
        )}

        <>
          <div className="h3-footer-companies">
            <h2>PayRetailers' companies</h2>
          </div>
          <Flex className="footer-transfeera">
            <GetLogo lang={lang} />
          </Flex>
        </>

        <Flex className="footer-end">
          <Flex className="footer-social">
            <a
              href="https://www.instagram.com/pay.retailers?igsh=MTRrbGh6dGl1enIydw=="
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon
                style={{
                  fontSize: "32px",
                }}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/pay-retailers/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedinIcon
                style={{
                  fontSize: "20px",
                }}
              />
            </a>
          </Flex>
          <Flex className="footer-copyrights">
            <span>
              Copyright © {currentYear} PayRetailers | {terms[lang].rights} |
              &nbsp;
              <a href={`/${lang}/${terms[lang].termsConditions.url}`}>
                {terms[lang].termsConditions.label}
              </a>
              <span> | </span>
              <a href={`/${lang}/${terms[lang].privacyPolicy.url}`}>
                {terms[lang].privacyPolicy.label}
              </a>
              <>
                  <span> | </span>
                  <a href={`/pt/politicas-br`}>
                    Politicas aplicáveis no Brasil
                  </a>
                </>
            </span>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}

export default FooterComp